/* istanbul ignore file */

export const fallback = (): Promise<{
	default: {};
}> => Promise.resolve({ default: {} });

export const cs = (): Promise<typeof import('../../i18n/cs')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-cs" */ '../../i18n/cs');

export const da = (): Promise<typeof import('../../i18n/da')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-da" */ '../../i18n/da');

export const de = (): Promise<typeof import('../../i18n/de')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-de" */ '../../i18n/de');

export const en = (): Promise<typeof import('../../i18n/en')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-en" */ '../../i18n/en');

export const engb = (): Promise<typeof import('../../i18n/en_GB')> =>
	import(
		/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-engb" */ '../../i18n/en_GB'
	);

export const enzz = (): Promise<typeof import('../../i18n/en_ZZ')> =>
	import(
		/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-enzz" */ '../../i18n/en_ZZ'
	);

export const es = (): Promise<typeof import('../../i18n/es')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-es" */ '../../i18n/es');

export const et = (): Promise<typeof import('../../i18n/et')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-et" */ '../../i18n/et');

export const fi = (): Promise<typeof import('../../i18n/fi')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-fi" */ '../../i18n/fi');

export const fr = (): Promise<typeof import('../../i18n/fr')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-fr" */ '../../i18n/fr');

export const hu = (): Promise<typeof import('../../i18n/hu')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-hu" */ '../../i18n/hu');

export const is = (): Promise<typeof import('../../i18n/is')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-is" */ '../../i18n/is');

export const it = (): Promise<typeof import('../../i18n/it')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-it" */ '../../i18n/it');

export const ja = (): Promise<typeof import('../../i18n/ja')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-ja" */ '../../i18n/ja');

export const ko = (): Promise<typeof import('../../i18n/ko')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-ko" */ '../../i18n/ko');

export const nb = (): Promise<typeof import('../../i18n/nb')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-nb" */ '../../i18n/nb');

export const nl = (): Promise<typeof import('../../i18n/nl')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-nl" */ '../../i18n/nl');

export const pl = (): Promise<typeof import('../../i18n/pl')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-pl" */ '../../i18n/pl');

export const pt = (): Promise<typeof import('../../i18n/pt_PT')> =>
	import(
		/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-pt-PT" */ '../../i18n/pt_PT'
	);

export const ptbr = (): Promise<typeof import('../../i18n/pt_BR')> =>
	import(
		/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-pt-BR" */ '../../i18n/pt_BR'
	);

export const ro = (): Promise<typeof import('../../i18n/ro')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-ro" */ '../../i18n/ro');

export const ru = (): Promise<typeof import('../../i18n/ru')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-ru" */ '../../i18n/ru');

export const sk = (): Promise<typeof import('../../i18n/sk')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-sk" */ '../../i18n/sk');

export const sv = (): Promise<typeof import('../../i18n/sv')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-sv" */ '../../i18n/sv');

export const tr = (): Promise<typeof import('../../i18n/tr')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-tr" */ '../../i18n/tr');

export const th = (): Promise<typeof import('../../i18n/th')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-th" */ '../../i18n/th');

export const uk = (): Promise<typeof import('../../i18n/uk')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-uk" */ '../../i18n/uk');

export const vi = (): Promise<typeof import('../../i18n/vi')> =>
	import(/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-vi" */ '../../i18n/vi');

export const zh = (): Promise<typeof import('../../i18n/zh')> =>
	import(
		/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-zh-ZH" */ '../../i18n/zh'
	);

export const zhtw = (): Promise<typeof import('../../i18n/zh_TW')> =>
	import(
		/* webpackChunkName: "@atlaskit-internal_async-people-teams-i18n-zh-TW" */ '../../i18n/zh_TW'
	);
